import { RAID_STORAGE_KEY } from '../index';

export const getRAID = () => window.localStorage.getItem(RAID_STORAGE_KEY);
